export default __webpack_public_path__ + "static/media/cladding23.f8260021.jpg";